
import { FormControl } from '@angular/forms';

export interface ValidationResult {
    [key: string]: boolean;
}

export class PasswordComplexityValidator {
    public static strong(control: FormControl): ValidationResult {
        const hasNumber = /\d/.test(control.value);
        const hasUpper = /[A-Z]/.test(control.value);
        const hasLower = /[a-z]/.test(control.value);
        // ConsoleLogger.logInfo('Num, Upp, Low', hasNumber, hasUpper, hasLower);
        const valid = hasNumber && hasUpper && hasLower;
        if (!valid) {
            return { strong: true };
        }
        return null;
    }

    public static hasUpper(control: FormControl): ValidationResult {
        const hasUpper = /[A-Z]/.test(control.value);
        // ConsoleLogger.logInfo('Num, Upp, Low', hasNumber, hasUpper, hasLower);
        if (!hasUpper) {
            return { upper: true };
        }
        return null;
    }
    public static hasLower(control: FormControl): ValidationResult {
        const hasLower = /[a-z]/.test(control.value);

        // ConsoleLogger.logInfo('Num, Upp, Low', hasNumber, hasUpper, hasLower);
        if (!hasLower) {
            return { lower: true };
        }
        return null;
    }
    public static hasNumber(control: FormControl): ValidationResult {
        const hasNumber = /\d/.test(control.value);

        // ConsoleLogger.logInfo('Num, Upp, Low', hasNumber, hasUpper, hasLower);
        if (!hasNumber) {
            return { number: true };
        }
        return null;
    }
}


// WEBPACK FOOTER //
// ./src/app/auth/forgot-password/reset-password/password-complexity.validator.ts